import config from 'constants/config'
import type { ExperimentConfig } from 'constants/experiments'
import { isAllowedToTriggerExperiment } from 'lib/optimizely/optimizelyUtils'

interface ChertoExperimentVariationOptions {
  overrideTrigger?: boolean
}

export function getChertoExperimentVariation(
  state: App.State,
  experiment: Pick<ExperimentConfig, 'id'>,
  options: ChertoExperimentVariationOptions = {},
): string | undefined {
  const experimentId = experiment.id
  if (!options.overrideTrigger && !isAllowedToTriggerExperiment(true, state.utm.content, experimentId)) {
    return undefined
  }

  const variationKey = config[`CHERTO_${experimentId}`] ?? state.cherto.chertoExperiments[experimentId]?.variationKey
  if (!variationKey || String(variationKey).toLowerCase() === 'off') {
    return undefined
  }
  return variationKey
}
